export class RemoveFilesParams {
  files: string[]

  constructor({ files }: { files: string[] }) {
    this.files = files
  }
}
